/**
 * Netx core
 * @module core
 */
import {setGlobal} from '@netx/core-next';
import Loading from './lib/netx-loading';
import Router from './lib/netx-routers-app';

import {appRouter} from '@netx/core-next/instance/router';
import {getPrefixedLogger} from '@netx/core-next/instance/logger';
import NetxURL from '@netx/core-next/url';

const logger = getPrefixedLogger('core');

export default {
	namespace: 'netx',
	initialize() {
		logger.silly('setting up module...');
		// We expect these to be set
		setGlobal({
			// this is dead, leaving in the event of a cannnot access x of undefined
			// should not come up... think all references have been removed
			custom: {},
			// Instantiate the global router
			router: appRouter,
			URL: NetxURL,
			// Routers
			Routers: {
				App: Router,
			},
			// Loading screen
			Loading: new Loading(),
		});

		// Start history
		Backbone.history.start({silent: true});

		// "bunldes" that do not depend on the full "core-app"
		if (
			window.location.hash.match(
				/share\/request\/((?!review|approve|reject).)*$/,
			)
		) {
			logger.silly('sending to share landing module...');
			return new Promise((resolve, reject) => {
				import(
					/* webpackChunkName: "core-share-link-landing" */ '@netx/core-share-link-landing'
				).then((ShareLinkLanding) => {
					logger.silly('loading share landing module...');
					dispatcher.trigger('netx:load:module', ShareLinkLanding.default, {
						loadUrl: true,
						error: reject,
						initialized: (args) => {
							logger.silly('initialized share landing module');
							resolve(args);
						},
					});
				});
			});
		} else if (window.location.hash.match(/uploads\/request\/(.)*$/)) {
			logger.silly('sending to core-upload-asset-request module...');
			return new Promise((resolve, reject) => {
				import(
					/* webpackChunkName: "core-upload-asset-request" */ '@netx/core-upload-asset-request'
				).then((UploadAssetRequest) => {
					logger.silly('loading core-upload-asset-request module...');
					dispatcher.trigger('netx:load:module', UploadAssetRequest.default, {
						loadUrl: true,
						error: reject,
						initialized: (args) => {
							logger.silly('initialized core-upload-asset-request module');
							resolve(args);
						},
					});
				});
			});
		}

		logger.silly('initializing module...');
		return new Promise((resolve, reject) => {
			// Bring in custom controller
			import(
				/* webpackChunkName: "core-module-dependencies" */ '@netx/core/controller'
			);
			import(
				/* webpackChunkName: "core-module-dependencies" */ '@netx/core-app'
			).then((App) => {
				// Initialize app
				dispatcher.trigger('netx:load:module', App.default, {
					error: reject,
					initialized: (args) => {
						logger.silly('initialized module');
						resolve(args);
					},
				});
			});
		});
	},
};
